t = require('views/internal/teacup-with-helpers')('error')

module.exports = t.renderable ({ isLoggedIn, url, errorType, modelType, email, nextActionUrl })->
  unconfirmedModel = (messageKey) ->
    t.div '.big-message.with-picture.quiet', ->
      t.img { src: require('images/TacoBouncer.png'), width: '459', height: '238' }

      t.h1 ->
        t.format 'roooooo-are-you'

      t.p ->
        t.format messageKey

      t.div '.callout', ->
        t.ol ->
          t.li ->
            t.format 'check-your-email-at-email', { email }
          t.li ->
            t.format 'look-for-an-email-with-the-subject-trello-account-confirmation'
          t.li ->
            t.format 'click-on-the-confirmation-link-done'

      t.p ->
        t.format 'dont-see-anything-from-us'
        t.raw ' '
        t.a '.quiet.js-resend-confirmation-email', { href: '#' }, ->
          t.format 'resend-confirmation-link'

  normalError = (headerKey, loggedInMessageKey, notLoggedInMessageKey) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format headerKey

      if !isLoggedIn
        t.p ->
          t.format loggedInMessageKey
      else
        t.p ->
          t.format notLoggedInMessageKey
      return

  invitationLinkError = (messageKey) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey

      t.p ->
        t.format 'ask-for-a-new-link'

  headingWithLinkError = (messageKey, linkKey, linkHref) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey

      t.p ->
        t.a '.quiet', { href: linkHref }, ->
          t.format linkKey

  headingError = (messageKey) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey


  switch errorType
    when 'notFound'
      normalError 'page-not-found',
        'this-page-may-be-private-you-may-be-able-to-view-it-by-logging-in',
        'this-page-may-be-private-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when 'boardNotFound'
      normalError 'board-not-found',
        'this-board-may-be-private-you-may-be-able-to-view-it-by-logging-in',
        'this-board-may-be-private-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when 'cardNotFound'
      normalError 'card-not-found',
        'this-card-may-be-on-a-private-board-you-may-be-able-to-view-it-by-logging-in',
        'this-card-may-be-on-a-private-board-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when 'boardInvitationNotFound'
      invitationLinkError 'board-invitation-not-valid'

    when 'orgInvitationNotFound'
      invitationLinkError 'org-invitation-not-valid'

    when 'unconfirmedOrgNotFound'
      unconfirmedModel 'please-confirm-your-email-address-to-view-this-org'

    when 'unconfirmedBoardNotFound'
      unconfirmedModel 'please-confirm-your-email-address-to-view-this-board'

    else
      t.div '.big-message.quiet', ->
        t.h1 ->
          t.format 'page-not-found'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/error.coffee